module.exports={
	"Form": "PhysicalAssetMaterialEditManifest",
	"Scope": "PhysicalAssetMaterial-Edit",
	"Descriptors":
	{
		"PhysicalAssetMaterialDetails.Code":
		{
			"Name": "Code",
			"Hash": "PhysicalAssetMaterial-Edit-Code",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "PhysicalAssetMaterial-Edit-Identity",
				"Group": "PhysicalAssetMaterial-Edit-Identity"
			}
		},
		"PhysicalAssetMaterialDetails.IDMaterial":
		{
			"Name": "Material",
			"Hash": "PhysicalAssetMaterial-Edit-IDMaterial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "PhysicalAssetMaterial-Edit-Details",
				"Group": "PhysicalAssetMaterial-Edit-Details",
				"Entity": "Material",
				"SearchFields":
				[
					"Name",
					"MaterialCode",
					"ItemCode"
				]
			}
		},
		"PhysicalAssetMaterialDetails.Material":
		{
			"Name": "Material",
			"Hash": "PhysicalAssetMaterial-Edit-Material",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "PhysicalAssetMaterial-Edit-Details",
				"Group": "PhysicalAssetMaterial-Edit-Details"
			}
		},
		"PhysicalAssetMaterialDetails.Description":
		{
			"Name": "Description",
			"Hash": "PhysicalAssetMaterial-Edit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "PhysicalAssetMaterial-Edit-Details",
				"Group": "PhysicalAssetMaterial-Edit-Details"
			}
		},
		"PhysicalAssetMaterialDetails.IDPhysicalAssetMaterial":
		{
			"Name": "IDPhysical Asset Material",
			"Hash": "PhysicalAssetMaterial-Edit-IDPhysicalAssetMaterial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "PhysicalAssetMaterial-Edit-DataAudit",
				"Group": "PhysicalAssetMaterial-Edit-DataAudit"
			}
		},
		"PhysicalAssetMaterialDetails.GUIDPhysicalAssetMaterial":
		{
			"Name": "GUIDPhysical Asset Material",
			"Hash": "PhysicalAssetMaterial-Edit-GUIDPhysicalAssetMaterial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "PhysicalAssetMaterial-Edit-DataAudit",
				"Group": "PhysicalAssetMaterial-Edit-DataAudit"
			}
		},
		"PhysicalAssetMaterialDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "PhysicalAssetMaterial-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "PhysicalAssetMaterial-Edit-DataAudit",
				"Group": "PhysicalAssetMaterial-Edit-DataAudit"
			}
		},
		"PhysicalAssetMaterialDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "PhysicalAssetMaterial-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "PhysicalAssetMaterial-Edit-DataAudit",
				"Group": "PhysicalAssetMaterial-Edit-DataAudit"
			}
		},
		"PhysicalAssetMaterialDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "PhysicalAssetMaterial-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "PhysicalAssetMaterial-Edit-DataAudit",
				"Group": "PhysicalAssetMaterial-Edit-DataAudit"
			}
		},
		"PhysicalAssetMaterialDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "PhysicalAssetMaterial-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "PhysicalAssetMaterial-Edit-DataAudit",
				"Group": "PhysicalAssetMaterial-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "PhysicalAssetMaterial-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "PhysicalAssetMaterial-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "PhysicalAssetMaterial-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "PhysicalAssetMaterial-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "PhysicalAssetMaterial-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "PhysicalAssetMaterial-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
